module.exports = __webpack_public_path__ + "img/almatyObl1.6a7b18e9.jpg";